// @flow

// Modules
import styled from 'styled-components';

// Styles
import { PRIMARY } from 'src/styles/palettes';

/**
 * Styles
 */

const Button: any = styled.button`
  height: auto;
  margin: 0 2px;
  padding: 0.6em 3em;
  font-weight: 900;
  font-size: 1em;
  border: 0;
  border-radius: 6px;
  white-space: nowrap;
  background-color: ${PRIMARY};
  cursor: pointer;

  :hover {
    transition: 0.7s;
    transition-property: background-color;
  }
`;

export default Button;
